module.exports = __webpack_public_path__ + "media/preview/expo@1x-dc9dab04.png";